export default "__VITE_ASSET__BIUlgSMW__"